import { Flow } from "./Chart/script/FlowRunner";

/**
 * [최종 데이터 가공 로직]
 * 1. 이미지 최상단(2025/04/23)부터 60행 제외.
 * 2. 그 다음 70행(과거 데이터 방향) 추출.
 * 3. 추출된 데이터를 뒤집어서(Reverse) 배열의 끝이 가장 최신이 되도록 정렬.
 * 4. 시가(4열)와 종가(1열) 매핑 유지.
 */

// --- 1. 초기 20일치 데이터 (가장 오래된 구간: 130행 -> 111행 방향) ---
const initialData = [
  { baseDd: "1",  openPrice: 17280, highPrice: 17480, lowPrice: 17120, closePrice: 17160 }, // (구) 130행
  { baseDd: "2",  openPrice: 17160, highPrice: 17400, lowPrice: 16990, closePrice: 17330 },
  { baseDd: "3",  openPrice: 17330, highPrice: 17440, lowPrice: 16860, closePrice: 17090 },
  { baseDd: "4",  openPrice: 17090, highPrice: 17180, lowPrice: 16920, closePrice: 17020 },
  { baseDd: "5",  openPrice: 17020, highPrice: 17120, lowPrice: 16810, closePrice: 16980 },
  { baseDd: "6",  openPrice: 16980, highPrice: 17060, lowPrice: 16720, closePrice: 16770 },
  { baseDd: "7",  openPrice: 16770, highPrice: 16860, lowPrice: 16640, closePrice: 16750 },
  { baseDd: "8",  openPrice: 16750, highPrice: 16810, lowPrice: 16630, closePrice: 16610 },
  { baseDd: "9",  openPrice: 16610, highPrice: 16710, lowPrice: 16510, closePrice: 16490 },
  { baseDd: "10", openPrice: 16490, highPrice: 16650, lowPrice: 16360, closePrice: 16450 },
  { baseDd: "11", openPrice: 16450, highPrice: 16550, lowPrice: 16430, closePrice: 16540 },
  { baseDd: "12", openPrice: 16540, highPrice: 16560, lowPrice: 16460, closePrice: 16430 },
  { baseDd: "13", openPrice: 16430, highPrice: 16510, lowPrice: 16380, closePrice: 16350 },
  { baseDd: "14", openPrice: 16320, highPrice: 16410, lowPrice: 16260, closePrice: 16260 },
  { baseDd: "15", openPrice: 16260, highPrice: 16370, lowPrice: 15990, closePrice: 16060 },
  { baseDd: "16", openPrice: 16060, highPrice: 16120, lowPrice: 15840, closePrice: 15960 },
  { baseDd: "17", openPrice: 15960, highPrice: 16050, lowPrice: 15860, closePrice: 15850 },
  { baseDd: "18", openPrice: 15850, highPrice: 15940, lowPrice: 15840, closePrice: 15880 },
  { baseDd: "19", openPrice: 15880, highPrice: 15930, lowPrice: 15720, closePrice: 15760 },
  { baseDd: "20", openPrice: 15760, highPrice: 15910, lowPrice: 15730, closePrice: 15810 }, // (구) 111행
];

// --- 2. 추가 50턴 데이터 (110행 -> 61행 방향으로 전진) ---
const remainingData = [
  { baseDd: "21", openPrice: 15810, highPrice: 15890, lowPrice: 15700, closePrice: 15710 },
  { baseDd: "22", openPrice: 15710, highPrice: 15870, lowPrice: 15700, closePrice: 15790 },
  { baseDd: "23", openPrice: 15790, highPrice: 15910, lowPrice: 15680, closePrice: 15650 },
  { baseDd: "24", openPrice: 15650, highPrice: 15870, lowPrice: 15550, closePrice: 15790 },
  { baseDd: "25", openPrice: 15790, highPrice: 15860, lowPrice: 15480, closePrice: 15500 },
  { baseDd: "26", openPrice: 15500, highPrice: 15560, lowPrice: 15300, closePrice: 15450 },
  { baseDd: "27", openPrice: 15450, highPrice: 15810, lowPrice: 15450, closePrice: 15750 },
  { baseDd: "28", openPrice: 15750, highPrice: 15870, lowPrice: 15320, closePrice: 15530 },
  { baseDd: "29", openPrice: 15530, highPrice: 15900, lowPrice: 15350, closePrice: 15770 },
  { baseDd: "30", openPrice: 15770, highPrice: 16250, lowPrice: 15630, closePrice: 16150 },
  { baseDd: "31", openPrice: 16150, highPrice: 16200, lowPrice: 16000, closePrice: 16050 },
  { baseDd: "32", openPrice: 16050, highPrice: 16160, lowPrice: 15930, closePrice: 16130 },
  { baseDd: "33", openPrice: 16130, highPrice: 16330, lowPrice: 16020, closePrice: 16250 },
  { baseDd: "34", openPrice: 16250, highPrice: 16270, lowPrice: 16040, closePrice: 16140 },
  { baseDd: "35", openPrice: 16140, highPrice: 16210, lowPrice: 16040, closePrice: 16150 },
  { baseDd: "36", openPrice: 16150, highPrice: 16400, lowPrice: 16120, closePrice: 16350 },
  { baseDd: "37", openPrice: 16350, highPrice: 16410, lowPrice: 16190, closePrice: 16330 },
  { baseDd: "38", openPrice: 16330, highPrice: 16900, lowPrice: 16320, closePrice: 16800 },
  { baseDd: "39", openPrice: 16800, highPrice: 16890, lowPrice: 16550, closePrice: 16550 },
  { baseDd: "40", openPrice: 16550, highPrice: 16900, lowPrice: 16480, closePrice: 16180 },
  { baseDd: "41", openPrice: 16180, highPrice: 16390, lowPrice: 16060, closePrice: 16080 },
  { baseDd: "42", openPrice: 16080, highPrice: 16200, lowPrice: 16010, closePrice: 16200 },
  { baseDd: "43", openPrice: 16200, highPrice: 16380, lowPrice: 16060, closePrice: 16300 },
  { baseDd: "44", openPrice: 16300, highPrice: 16400, lowPrice: 16180, closePrice: 16200 },
  { baseDd: "45", openPrice: 16200, highPrice: 16200, lowPrice: 15790, closePrice: 15850 },
  { baseDd: "46", openPrice: 15850, highPrice: 16180, lowPrice: 15830, closePrice: 15860 },
  { baseDd: "47", openPrice: 15860, highPrice: 15870, lowPrice: 15660, closePrice: 15680 },
  { baseDd: "48", openPrice: 15680, highPrice: 15810, lowPrice: 15590, closePrice: 15490 },
  { baseDd: "49", openPrice: 15490, highPrice: 15550, lowPrice: 15260, closePrice: 15370 },
  { baseDd: "50", openPrice: 15370, highPrice: 15650, lowPrice: 15370, closePrice: 15480 },
  { baseDd: "51", openPrice: 15480, highPrice: 15550, lowPrice: 15320, closePrice: 15370 },
  { baseDd: "52", openPrice: 15370, highPrice: 15450, lowPrice: 15280, closePrice: 15380 },
  { baseDd: "53", openPrice: 15380, highPrice: 15410, lowPrice: 15140, closePrice: 15150 },
  { baseDd: "54", openPrice: 15150, highPrice: 15460, lowPrice: 15150, closePrice: 15300 },
  { baseDd: "55", openPrice: 15300, highPrice: 15470, lowPrice: 15210, closePrice: 15310 },
  { baseDd: "56", openPrice: 15310, highPrice: 15580, lowPrice: 15140, closePrice: 15410 },
  { baseDd: "57", openPrice: 15410, highPrice: 15640, lowPrice: 15410, closePrice: 15560 },
  { baseDd: "58", openPrice: 15560, highPrice: 15650, lowPrice: 15500, closePrice: 15530 },
  { baseDd: "59", openPrice: 15530, highPrice: 15750, lowPrice: 15520, closePrice: 15650 },
  { baseDd: "60", openPrice: 15650, highPrice: 15840, lowPrice: 15630, closePrice: 15790 },
  { baseDd: "61", openPrice: 15790, highPrice: 15870, lowPrice: 15700, closePrice: 15710 },
  { baseDd: "62", openPrice: 15710, highPrice: 15890, lowPrice: 15700, closePrice: 15810 },
  { baseDd: "63", openPrice: 15810, highPrice: 15910, lowPrice: 15730, closePrice: 15760 },
  { baseDd: "64", openPrice: 15760, highPrice: 15930, lowPrice: 15720, closePrice: 15880 },
  { baseDd: "65", openPrice: 15880, highPrice: 15940, lowPrice: 15840, closePrice: 15850 },
  { baseDd: "66", openPrice: 15850, highPrice: 16050, lowPrice: 15860, closePrice: 15960 },
  { baseDd: "67", openPrice: 15960, highPrice: 16120, lowPrice: 15840, closePrice: 16060 },
  { baseDd: "68", openPrice: 16060, highPrice: 16370, lowPrice: 15990, closePrice: 16260 },
  { baseDd: "69", openPrice: 16260, highPrice: 16410, lowPrice: 16260, closePrice: 16320 },
  { baseDd: "70", openPrice: 16320, highPrice: 16400, lowPrice: 16260, closePrice: 16380 }, // (구) 61행
];

export const gameEx: Flow[] = [
  {
    step: 1,
    action: [
      { type: 'RESET_ALL', payload: {} },
      { type: 'ADD_REGION', payload: { id: 'main', width: "100%", height: "100%", top: 0, left: 0 } },
      { 
        type: 'ADD_LAYER', 
        payload: { 
          regionId: 'main', 
          layer: { 
            id: 'price-layer', 
            width: "92%", height: "85%", top: "5%", left: "4%",
            yAxis: { orient: 'right', showGrid: true, yMinAxisSource: 'all', yMaxAxisSource: 'all' } 
          } 
        } 
      },
      { type: 'ADD_DATA', payload: { data: initialData } },
      {
        type: 'ADD_GRAPH',
        payload: {
          regionId: 'main', layerId: 'price-layer',
          graph: {
            id: 'candle-game', type: 'candle',
            mapping: { xAxis: 'baseDd', open: 'openPrice', close: 'closePrice', high: 'highPrice', low: 'lowPrice' },
            style: { positiveColor: '#ef5350', negativeColor: '#3686ff' }
          }
        }
      },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'price-layer',
          box: {
            id: 'start-box',
            title: '시간 순서 교정 완료',
            content: '과거에서 현재로 흐르는 70일간의 데이터를 로드했습니다.',
            x: '50%', y: '40%',
            nextStep: 2,
            btnContent: '시뮬레이션 시작'
          }
        }
      }
    ]
  },
  {
    step: 2,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'price-layer', boxId: 'start-box' } }
    ]
  },
  ...remainingData.map((dataItem, index) => ({
    step: index + 3,
    action: [
      { type: 'ADD_DATA', payload: { data: [dataItem] } }
    ]
  })),
  {
    step: 53,
    action: [
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'price-layer',
          box: {
            id: 'end-box',
            title: '시뮬레이션 종료',
            content: '수고하셨습니다!',
            x: '50%', y: '40%',
            nextStep: 54,
            btnContent: '마침'
          }
        }
      }
    ]
  }
];